enum DataRowStyle {
    SLIM,
}

export default DataRowStyle;
